import { render } from "./Userverwaltung.vue?vue&type=template&id=e74d7a12"
import script from "./Userverwaltung.vue?vue&type=script&lang=js"
export * from "./Userverwaltung.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__